import { theme } from '@chakra-ui/react';
import { rem } from 'polished';

export const datePickerStyle = {
  input: {
    w: 'full',
  },

  // Customizations for the date picker popup to match design

  '.react-datepicker': {
    p: 'space.16',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    borderRadius: 0,
    borderWidth: '1px',
    borderColor: 'gray.2',
    fontSize: 'md',
    // minWidth: rem(510), // Needed to prevent time picker collapsing below the dates
  },

  '.react-datepicker-popper': {
    [`@media screen and (max-width: ${theme.breakpoints.md})`]: {
      // had to reset style with !important cause they were somehow set directly via style property on component
      position: 'fixed !important',
      inset: '0px !important',
      transform: 'initial !important',

      display: 'flex',
    },
  },

  '.react-datepicker-popper > div': {
    [`@media screen and (max-width: ${theme.breakpoints.md})`]: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      alignSelf: 'center',
      flexDirection: 'column',
    },
  },

  '.react-datepicker__triangle': {
    display: 'none',
  },

  '.react-datepicker__navigation': {
    top: rem(24),
    color: 'black',
    '&--previous': {
      left: rem(16),
    },
    '&--next': {
      right: rem(16),
    },

    '&-icon::before': {
      borderColor: 'black',
    },
  },

  '.react-datepicker__header': {
    borderBottomWidth: 0,
    background: 'transparent',
  },

  '.react-datepicker__current-month': {
    fontSize: 'md',
  },

  '.react-datepicker__month': {
    margin: 0,
  },

  '.react-datepicker__day, .react-datepicker__day-name': {
    padding: rem(10),
    width: rem(48),
    borderWidth: '1px',
    margin: '-1px 0 0 -1px',
  },

  '.react-datepicker__day': {
    borderColor: 'gray.2',

    '&:hover': {
      borderRadius: 0,
      background: 'gray.1',

      '&.react-datepicker__day--selected': {
        background: 'black',
      },
    },

    '&--outside-month': {
      color: 'gray.5',
      borderColor: 'transparent',
    },

    '&--keyboard-selected': {
      borderRadius: 0,
      background: 'transparent',
      color: 'black',
    },

    '&--today': {
      borderRadius: 0,
      background: 'gray.1',
      fontWeight: 'normal',
    },

    '&--selected': {
      borderRadius: 0,
      background: 'black',
    },
  },

  '.react-datepicker__day-name': {
    borderColor: 'transparent',
    color: 'gray.4',
    fontSize: 'xs',
    paddingBottom: 0,
  },

  '.react-datepicker__input-time-container': {
    ml: 0,
    mt: 'space.16',
    width: '100%',

    '.react-datepicker-time__caption': {
      display: 'block',
      mb: 'space.8',
    },

    '.react-datepicker-time__input': {
      ml: 0,
      borderRadius: 'radius.4',
      borderWidth: '1px',
      borderColor: 'gray.2',
      width: '100%',
    },
  },

  '.react-datepicker-time__input-container': {
    width: '100%',
  },

  '.react-datepicker-time__input': {
    width: '50%',
  },

  '.react-datepicker__header--time': {
    borderBottomColor: 'gray.2',
    borderBottomWidth: '1px',
  },
};
